/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateKitaDocumentDTO } from '../dto';
// @ts-ignore
import { CreateKitaIntervalDTO } from '../dto';
// @ts-ignore
import { IdentifierDTO } from '../dto';
// @ts-ignore
import { KitaDocumentTenantListDTO } from '../dto';
// @ts-ignore
import { KitaDocumentsDTO } from '../dto';
// @ts-ignore
import { KitaIntervalTenantListDTO } from '../dto';
// @ts-ignore
import { UploadLinkDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
/**
 * KitaApi - axios parameter creator
 * @export
 */
export const KitaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary upload a new kita document
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateKitaDocumentDTO} createKitaDocumentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument: async (tenantId: string, employeeId: string, createKitaDocumentDTO: CreateKitaDocumentDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createDocument', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createDocument', 'employeeId', employeeId)
            // verify required parameter 'createKitaDocumentDTO' is not null or undefined
            assertParamExists('createDocument', 'createKitaDocumentDTO', createKitaDocumentDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/kita/documents`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createKitaDocumentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a new kita interval
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateKitaIntervalDTO} createKitaIntervalDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterval: async (tenantId: string, employeeId: string, createKitaIntervalDTO: CreateKitaIntervalDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createInterval', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createInterval', 'employeeId', employeeId)
            // verify required parameter 'createKitaIntervalDTO' is not null or undefined
            assertParamExists('createInterval', 'createKitaIntervalDTO', createKitaIntervalDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/kita/intervals`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createKitaIntervalDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a form POST upload link for uploading a document. Refer to https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html on how to implement the form POST.
         * @summary create a presigned upload link
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadLink: async (tenantId: string, employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createUploadLink', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createUploadLink', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/kita/documents/createUploadLink`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete an existing kita document
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (tenantId: string, employeeId: string, documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteDocument', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteDocument', 'employeeId', employeeId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteDocument', 'documentId', documentId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/kita/documents/{documentId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the interval with the given ID.
         * @summary delete a single interval
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} intervalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInterval: async (tenantId: string, employeeId: string, intervalId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteInterval', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteInterval', 'employeeId', employeeId)
            // verify required parameter 'intervalId' is not null or undefined
            assertParamExists('deleteInterval', 'intervalId', intervalId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/kita/intervals/{intervalId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"intervalId"}}`, encodeURIComponent(String(intervalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: async (tenantId: string, employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getDocuments', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getDocuments', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/kita/documents`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all kita intervals for a tenant
         * @param {string} month 
         * @param {string} tenantId 
         * @param {string} [department] 
         * @param {string} [filter] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKitaReport: async (month: string, tenantId: string, department?: string, filter?: string, sortBy?: Array<string>, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getKitaReport', 'month', month)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getKitaReport', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/kita/reports/intervals`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the detail report for a tenant
         * @param {string} month 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceiptDetailsExport: async (month: string, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getReceiptDetailsExport', 'month', month)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getReceiptDetailsExport', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/kita/reports/details`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all kita documents for a tenant
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKitaDocuments: async (tenantId: string, filter?: string, sortBy?: Array<string>, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listKitaDocuments', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/kita/documents`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KitaApi - functional programming interface
 * @export
 */
export const KitaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KitaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary upload a new kita document
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateKitaDocumentDTO} createKitaDocumentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocument(tenantId: string, employeeId: string, createKitaDocumentDTO: CreateKitaDocumentDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentifierDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocument(tenantId, employeeId, createKitaDocumentDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create a new kita interval
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateKitaIntervalDTO} createKitaIntervalDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInterval(tenantId: string, employeeId: string, createKitaIntervalDTO: CreateKitaIntervalDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentifierDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInterval(tenantId, employeeId, createKitaIntervalDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a form POST upload link for uploading a document. Refer to https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html on how to implement the form POST.
         * @summary create a presigned upload link
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUploadLink(tenantId: string, employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLinkDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUploadLink(tenantId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary delete an existing kita document
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument(tenantId: string, employeeId: string, documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(tenantId, employeeId, documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete the interval with the given ID.
         * @summary delete a single interval
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} intervalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInterval(tenantId: string, employeeId: string, intervalId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInterval(tenantId, employeeId, intervalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocuments(tenantId: string, employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KitaDocumentsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(tenantId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get all kita intervals for a tenant
         * @param {string} month 
         * @param {string} tenantId 
         * @param {string} [department] 
         * @param {string} [filter] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKitaReport(month: string, tenantId: string, department?: string, filter?: string, sortBy?: Array<string>, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KitaIntervalTenantListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKitaReport(month, tenantId, department, filter, sortBy, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get the detail report for a tenant
         * @param {string} month 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReceiptDetailsExport(month: string, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReceiptDetailsExport(month, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get all kita documents for a tenant
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listKitaDocuments(tenantId: string, filter?: string, sortBy?: Array<string>, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KitaDocumentTenantListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listKitaDocuments(tenantId, filter, sortBy, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KitaApi - factory interface
 * @export
 */
export const KitaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KitaApiFp(configuration)
    return {
        /**
         * 
         * @summary upload a new kita document
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateKitaDocumentDTO} createKitaDocumentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument(tenantId: string, employeeId: string, createKitaDocumentDTO: CreateKitaDocumentDTO, options?: any): AxiosPromise<IdentifierDTO> {
            return localVarFp.createDocument(tenantId, employeeId, createKitaDocumentDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a new kita interval
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateKitaIntervalDTO} createKitaIntervalDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterval(tenantId: string, employeeId: string, createKitaIntervalDTO: CreateKitaIntervalDTO, options?: any): AxiosPromise<IdentifierDTO> {
            return localVarFp.createInterval(tenantId, employeeId, createKitaIntervalDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a form POST upload link for uploading a document. Refer to https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html on how to implement the form POST.
         * @summary create a presigned upload link
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadLink(tenantId: string, employeeId: string, options?: any): AxiosPromise<UploadLinkDTO> {
            return localVarFp.createUploadLink(tenantId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete an existing kita document
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(tenantId: string, employeeId: string, documentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDocument(tenantId, employeeId, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the interval with the given ID.
         * @summary delete a single interval
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} intervalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInterval(tenantId: string, employeeId: string, intervalId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteInterval(tenantId, employeeId, intervalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(tenantId: string, employeeId: string, options?: any): AxiosPromise<KitaDocumentsDTO> {
            return localVarFp.getDocuments(tenantId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all kita intervals for a tenant
         * @param {string} month 
         * @param {string} tenantId 
         * @param {string} [department] 
         * @param {string} [filter] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKitaReport(month: string, tenantId: string, department?: string, filter?: string, sortBy?: Array<string>, page?: number, pageSize?: number, options?: any): AxiosPromise<KitaIntervalTenantListDTO> {
            return localVarFp.getKitaReport(month, tenantId, department, filter, sortBy, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the detail report for a tenant
         * @param {string} month 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceiptDetailsExport(month: string, tenantId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getReceiptDetailsExport(month, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all kita documents for a tenant
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKitaDocuments(tenantId: string, filter?: string, sortBy?: Array<string>, page?: number, pageSize?: number, options?: any): AxiosPromise<KitaDocumentTenantListDTO> {
            return localVarFp.listKitaDocuments(tenantId, filter, sortBy, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDocument operation in KitaApi.
 * @export
 * @interface KitaApiCreateDocumentRequest
 */
export interface KitaApiCreateDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof KitaApiCreateDocument
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiCreateDocument
     */
    readonly employeeId: string

    /**
     * 
     * @type {CreateKitaDocumentDTO}
     * @memberof KitaApiCreateDocument
     */
    readonly createKitaDocumentDTO: CreateKitaDocumentDTO
}

/**
 * Request parameters for createInterval operation in KitaApi.
 * @export
 * @interface KitaApiCreateIntervalRequest
 */
export interface KitaApiCreateIntervalRequest {
    /**
     * 
     * @type {string}
     * @memberof KitaApiCreateInterval
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiCreateInterval
     */
    readonly employeeId: string

    /**
     * 
     * @type {CreateKitaIntervalDTO}
     * @memberof KitaApiCreateInterval
     */
    readonly createKitaIntervalDTO: CreateKitaIntervalDTO
}

/**
 * Request parameters for createUploadLink operation in KitaApi.
 * @export
 * @interface KitaApiCreateUploadLinkRequest
 */
export interface KitaApiCreateUploadLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof KitaApiCreateUploadLink
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiCreateUploadLink
     */
    readonly employeeId: string
}

/**
 * Request parameters for deleteDocument operation in KitaApi.
 * @export
 * @interface KitaApiDeleteDocumentRequest
 */
export interface KitaApiDeleteDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof KitaApiDeleteDocument
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiDeleteDocument
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiDeleteDocument
     */
    readonly documentId: string
}

/**
 * Request parameters for deleteInterval operation in KitaApi.
 * @export
 * @interface KitaApiDeleteIntervalRequest
 */
export interface KitaApiDeleteIntervalRequest {
    /**
     * 
     * @type {string}
     * @memberof KitaApiDeleteInterval
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiDeleteInterval
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiDeleteInterval
     */
    readonly intervalId: string
}

/**
 * Request parameters for getDocuments operation in KitaApi.
 * @export
 * @interface KitaApiGetDocumentsRequest
 */
export interface KitaApiGetDocumentsRequest {
    /**
     * 
     * @type {string}
     * @memberof KitaApiGetDocuments
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiGetDocuments
     */
    readonly employeeId: string
}

/**
 * Request parameters for getKitaReport operation in KitaApi.
 * @export
 * @interface KitaApiGetKitaReportRequest
 */
export interface KitaApiGetKitaReportRequest {
    /**
     * 
     * @type {string}
     * @memberof KitaApiGetKitaReport
     */
    readonly month: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiGetKitaReport
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiGetKitaReport
     */
    readonly department?: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiGetKitaReport
     */
    readonly filter?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof KitaApiGetKitaReport
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof KitaApiGetKitaReport
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof KitaApiGetKitaReport
     */
    readonly pageSize?: number
}

/**
 * Request parameters for getReceiptDetailsExport operation in KitaApi.
 * @export
 * @interface KitaApiGetReceiptDetailsExportRequest
 */
export interface KitaApiGetReceiptDetailsExportRequest {
    /**
     * 
     * @type {string}
     * @memberof KitaApiGetReceiptDetailsExport
     */
    readonly month: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiGetReceiptDetailsExport
     */
    readonly tenantId: string
}

/**
 * Request parameters for listKitaDocuments operation in KitaApi.
 * @export
 * @interface KitaApiListKitaDocumentsRequest
 */
export interface KitaApiListKitaDocumentsRequest {
    /**
     * 
     * @type {string}
     * @memberof KitaApiListKitaDocuments
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KitaApiListKitaDocuments
     */
    readonly filter?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof KitaApiListKitaDocuments
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof KitaApiListKitaDocuments
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof KitaApiListKitaDocuments
     */
    readonly pageSize?: number
}

/**
 * KitaApi - object-oriented interface
 * @export
 * @class KitaApi
 * @extends {BaseAPI}
 */
export class KitaApi extends BaseAPI {
    /**
     * 
     * @summary upload a new kita document
     * @param {KitaApiCreateDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitaApi
     */
    public createDocument(requestParameters: KitaApiCreateDocumentRequest, options?: AxiosRequestConfig) {
        return KitaApiFp(this.configuration).createDocument(requestParameters.tenantId, requestParameters.employeeId, requestParameters.createKitaDocumentDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a new kita interval
     * @param {KitaApiCreateIntervalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitaApi
     */
    public createInterval(requestParameters: KitaApiCreateIntervalRequest, options?: AxiosRequestConfig) {
        return KitaApiFp(this.configuration).createInterval(requestParameters.tenantId, requestParameters.employeeId, requestParameters.createKitaIntervalDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a form POST upload link for uploading a document. Refer to https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html on how to implement the form POST.
     * @summary create a presigned upload link
     * @param {KitaApiCreateUploadLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitaApi
     */
    public createUploadLink(requestParameters: KitaApiCreateUploadLinkRequest, options?: AxiosRequestConfig) {
        return KitaApiFp(this.configuration).createUploadLink(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete an existing kita document
     * @param {KitaApiDeleteDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitaApi
     */
    public deleteDocument(requestParameters: KitaApiDeleteDocumentRequest, options?: AxiosRequestConfig) {
        return KitaApiFp(this.configuration).deleteDocument(requestParameters.tenantId, requestParameters.employeeId, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the interval with the given ID.
     * @summary delete a single interval
     * @param {KitaApiDeleteIntervalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitaApi
     */
    public deleteInterval(requestParameters: KitaApiDeleteIntervalRequest, options?: AxiosRequestConfig) {
        return KitaApiFp(this.configuration).deleteInterval(requestParameters.tenantId, requestParameters.employeeId, requestParameters.intervalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {KitaApiGetDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitaApi
     */
    public getDocuments(requestParameters: KitaApiGetDocumentsRequest, options?: AxiosRequestConfig) {
        return KitaApiFp(this.configuration).getDocuments(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all kita intervals for a tenant
     * @param {KitaApiGetKitaReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitaApi
     */
    public getKitaReport(requestParameters: KitaApiGetKitaReportRequest, options?: AxiosRequestConfig) {
        return KitaApiFp(this.configuration).getKitaReport(requestParameters.month, requestParameters.tenantId, requestParameters.department, requestParameters.filter, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the detail report for a tenant
     * @param {KitaApiGetReceiptDetailsExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitaApi
     */
    public getReceiptDetailsExport(requestParameters: KitaApiGetReceiptDetailsExportRequest, options?: AxiosRequestConfig) {
        return KitaApiFp(this.configuration).getReceiptDetailsExport(requestParameters.month, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all kita documents for a tenant
     * @param {KitaApiListKitaDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitaApi
     */
    public listKitaDocuments(requestParameters: KitaApiListKitaDocumentsRequest, options?: AxiosRequestConfig) {
        return KitaApiFp(this.configuration).listKitaDocuments(requestParameters.tenantId, requestParameters.filter, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
